import {
  TenantHotelSubscriptionTransaction,
  TenantHotelSubscriptionTransactionsFilters,
  TenantHotelSubscriptionTransactionsResponse,
} from "@/types/tenant-subscription";

type ApiSubscriptionTransaction = {
  id: string;
  tenantSubscriptionId: string;
  tenantId?: string;
  stripeInvoiceId: string;
  stripePaymentIntentId: string | null;
  amount: number;
  currency: string;
  status: TenantHotelSubscriptionTransaction["status"];
  invoicePdfUrl: string | null;
  createdAt: string;
  updatedAt?: string;
  tenant?: TenantHotelSubscriptionTransaction["tenant"];
  hotel?: TenantHotelSubscriptionTransaction["hotel"] | null;
  subscription?: {
    id: string;
    plan?: TenantHotelSubscriptionTransaction["plan"];
  };
};

type ApiSubscriptionTransactionsResponse = {
  transactions?: ApiSubscriptionTransaction[];
  items?: TenantHotelSubscriptionTransaction[];
  total?: number;
  limit?: number;
  offset?: number;
};

const EMPTY_HOTEL = {
  id: "",
  name: "-",
};

const EMPTY_PLAN = {
  id: "",
  title: "-",
};

function mapSubscriptionTransaction(
  transaction: ApiSubscriptionTransaction,
): TenantHotelSubscriptionTransaction {
  return {
    id: transaction.id,
    subscriptionId:
      transaction.subscription?.id ?? transaction.tenantSubscriptionId,
    tenantSubscriptionId: transaction.tenantSubscriptionId,
    tenantId: transaction.tenantId,
    tenant: transaction.tenant,
    hotel: transaction.hotel ?? EMPTY_HOTEL,
    plan: transaction.subscription?.plan ?? EMPTY_PLAN,
    stripeInvoiceId: transaction.stripeInvoiceId,
    stripePaymentIntentId: transaction.stripePaymentIntentId,
    amount: transaction.amount,
    currency: transaction.currency,
    status: transaction.status,
    invoicePdfUrl: transaction.invoicePdfUrl,
    createdAt: transaction.createdAt,
    updatedAt: transaction.updatedAt,
  };
}

export function normalizeSubscriptionTransactionsResponse(
  response: ApiSubscriptionTransactionsResponse,
  filters?: TenantHotelSubscriptionTransactionsFilters,
): TenantHotelSubscriptionTransactionsResponse {
  if (Array.isArray(response.items)) {
    return {
      items: response.items,
      total: response.total ?? response.items.length,
      limit: response.limit ?? filters?.limit ?? response.items.length,
      offset: response.offset ?? filters?.offset ?? 0,
    };
  }

  const transactions = response.transactions ?? [];

  return {
    items: transactions.map(mapSubscriptionTransaction),
    total: response.total ?? transactions.length,
    limit: response.limit ?? filters?.limit ?? transactions.length,
    offset: response.offset ?? filters?.offset ?? 0,
  };
}
